import { render } from "./LookUpEditor.vue?vue&type=template&id=0a808cc0&ts=true"
import script from "./LookUpEditor.vue?vue&type=script&lang=ts"
export * from "./LookUpEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/crud/infrastructure/search/LookUpEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a808cc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a808cc0', __exports__)) {
    api.reload('0a808cc0', __exports__)
  }
  
  module.hot.accept("./LookUpEditor.vue?vue&type=template&id=0a808cc0&ts=true", () => {
    api.rerender('0a808cc0', render)
  })

}


export default __exports__